import dayjs from "dayjs";
import { DateFilterRangeList } from "../../hooks/useCalenderFilter";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const compareSubmissionDates = (submissionDate1, submissionDate2) => {
  return submissionDate1 === submissionDate2;
};

export const isFirstCalenderSelection = (submissionDate) => {
  const firstSelection = convertDayJsToDateRange(
    DateFilterRangeList[DateFilterRangeList.length - 1].getValue()
  );
  return (
    compareSubmissionDates(
      submissionDate.startDate,
      firstSelection.startDate
    ) && compareSubmissionDates(submissionDate.endDate, firstSelection.endDate)
  );
};

export const getMonthRange = () => {
  let monthRange = [];
  const month = new Date().getFullYear();
  months.map((item, index) => {
    monthRange.push({ month: item, value: index + 1 });
  });
  return monthRange;
};

export const getMonthFromValue = (value) => {
  return value <= months.length ? months[value - 1] : "Month";
};

export const getMonthQueryRange = (month, year, type = "string") => {
  if (!month || !year) return false;
  return type === "string"
    ? `&from_date=${year}-${month}-01&to_date=${year}-${month}-31`
    : { from_date: `${year}-${month}-01`, to_date: `${year}-${month}-31` };
};

export const getYearRange = () => {
  let yearRange = [];
  const year = new Date().getFullYear();
  for (let i = 2021; i < year; i++) {
    yearRange.push({ year: i, value: i });
  }
  yearRange.push({ year: "This year", value: year });
  return yearRange.reverse();
};

export const convertDayJsToDateRange = (dateObj) => {
  const startDate = `${dateObj[0].date()}-${
    dateObj[0].month() + 1
  }-${dateObj[0].year()}`;
  const endDate = `${dateObj[1].date()}-${
    dateObj[1].month() + 1
  }-${dateObj[1].year()}`;
  return { startDate, endDate };
};

export const getDateTime = (date = new Date()) => {
  return `${date.getFullYear()}-${date.getMonth()}-${date.getDay()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
};

export const getStyledDateTime = (date = new Date().toString()) => {
  const parsed_date = new Date(date);
  let hour = parsed_date.getHours();
  let hourFormat = hour >= 12 ? "PM" : "AM";
  hour = hour >= 12 ? hour - 12 : hour;
  return `${
    months[parsed_date.getMonth()]
  } ${parsed_date.getDate()}, ${parsed_date.getFullYear()} at ${hour}:${parsed_date.getMinutes()} ${hourFormat} UTC`;
};

export const getStyledShortDate = (date) => {
  if (!date) return date;
  const dateObj = new Date(date);
  return `${months[dateObj.getMonth()]} ${dateObj.getFullYear()}`;
};

export const getUtcDateTime = (d) => {
  // const utcDateString = d;
  // console.warn('utcDateString', utcDateString)
  // const utcDate = new Date(utcDateString);
  // const utcString = utcDate.toUTCString();
  if (!d) return "-";
  const date = new Date(d);
  // Define options for formatting
  const options = {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  // Convert the date to the desired format
  const formattedDate = date.toLocaleString("en-US", options) + " UTC";

  return formattedDate;
};
export const getUtcDateTimeTwo = (d) => {
  // const utcDateString = d;
  // console.warn('utcDateString', utcDateString)
  // const utcDate = new Date(utcDateString);
  // const utcString = utcDate.toUTCString();
  if (!d) return "-";
  const date = new Date(d);
  // Define options for formatting
  const options = {
    year: "numeric",
    month: "long",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  // Convert the date to the desired format
  const formattedDate = date.toLocaleString("en-US", options) + " UTC";

  return formattedDate;
};
export const getUtcDate = (d) => {
  // const utcDateString = d;
  // console.warn('utcDateString', utcDateString)
  // const utcDate = new Date(utcDateString);
  // const utcString = utcDate.toUTCString();
  if (!d) return "-";
  const date = new Date(d);
  // Define options for formatting
  const options = {
    year: "numeric",
    month: "long",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  // Convert the date to the desired format
  const formattedDate = date.toLocaleString("en-US", options) + " UTC";

  return formattedDate.split("at")[0];
};

export const getUtcDate1 = (d) => {
  if (!d) return "-";
  const date = new Date(d);

  // Define options for formatting with short month names
  const options = {
    year: "numeric",
    month: "short", // Use "short" for short month names
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  // Convert the date to the desired format
  const formattedDate = date.toLocaleString("en-US", options) + " UTC";

  return formattedDate;
};

export const getUtcTime = (d) => {
  // const utcDateString = d;
  // console.warn('utcDateString', utcDateString)
  // const utcDate = new Date(utcDateString);
  // const utcString = utcDate.toUTCString();
  if (!d) return "-";
  const date = new Date(d);
  // Define options for formatting
  const options = {
    year: "numeric",
    month: "long",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  // Convert the date to the desired format
  const formattedDate = date.toLocaleString("en-US", options) + " UTC";
  // console.warn("formattedDate", formattedDate);
  let str = "at" + formattedDate.split("at")[1];

  return str;
};
export const getUtcDateTwo = (d) => {
  // const utcDateString = d;
  // console.warn('utcDateString', utcDateString)
  // const utcDate = new Date(utcDateString);
  // const utcString = utcDate.toUTCString();
  if (!d) return "-";
  const date = new Date(d);
  // Define options for formatting
  const options = {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  // Convert the date to the desired format
  const formattedDate = date.toLocaleString("en-US", options) + " UTC";

  return formattedDate.split(",")[0] + ", " + formattedDate.split(",")[1];
};
export const getUtcTimeTwo = (d) => {
  // const utcDateString = d;
  // console.warn('utcDateString', utcDateString)
  // const utcDate = new Date(utcDateString);
  // const utcString = utcDate.toUTCString();
  if (!d) return "-";
  const date = new Date(d);
  // Define options for formatting
  const options = {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  // Convert the date to the desired format
  const formattedDate = date.toLocaleString("en-US", options) + " UTC";
  // console.warn("formattedDatetime", formattedDate);
  let str = " At" + formattedDate.split(",")[2];

  return str;
};

export const getDateApiFormat = (string) => {
  const inputDate = new Date(string);
  const year = inputDate.getFullYear();
  const month = String(inputDate.getMonth() + 1).padStart(2, "0");
  const day = String(inputDate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const getAbsoluteImageURI = (uri) => {
  return "https://vsclips.s3.us-east-2.amazonaws.com/" + uri;
};

export const getAbsoluteDownloadURI = (uri) => {
  return "https://vrl.sn/vsdownload/" + uri;
};

export const sampleMonthsValueArray = [
  { month: "January", value: 1 },
  { month: "February", value: 2 },
  { month: "March", value: 3 },
  { month: "April", value: 4 },
  { month: "May", value: 5 },
  { month: "June", value: 6 },
  { month: "July", value: 7 },
  { month: "August", value: 8 },
  { month: "September", value: 9 },
  { month: "October", value: 10 },
  { month: "November", value: 11 },
  { month: "December", value: 12 },
];

export const sampleCountriesArray = [
  "United States",
  "Canada",
  "United Kingdom",
  "Australia",
  "Germany",
  "France",
  "Japan",
  "India",
  "Brazil",
  "China",
];
const yearsList = (back) => {
  const year = new Date().getFullYear();
  return Array.from({ length: back }, (v, i) => year - back + i + 1);
};

export const sampleYearList = yearsList(3);

export const sampleContentBuyers = [1, 2, 3, 4, 5, 6, 7, 8, 9];

export const sampleDisplayList = ["Published only"];

export function concatHostAndImagePath(imagePath) {
  let host = process.env.REACT_APP_ASSET_URL;
  imagePath = imagePath?.replace(/^\//, "");
  // console.warn('vid url',`${host}/${imagePath}`)
  return `${host}/${imagePath}`;
}
export function concatHostAndVideoPath(videoPath) {
  let host = process.env.REACT_APP_PLAY_VIDEO_URL;
  videoPath = videoPath?.replace(/^\//, "");
  //   console.warn('vid url',`${host}/${videoPath}`)
  //   console.warn(process.env ,"env")
  // console.warn(process.env, "env");
  return `${host}/${videoPath}`;
}
export function concatDownloadPath(imagePath) {
  let host = process.env.REACT_APP_DOWNLOAD_URL;
  imagePath = imagePath?.replace(/^\//, "");
  return `${host}/${imagePath}`;
}
export function concatFileDownloadPath(filePath) {
  let host = process.env.REACT_APP_FILE_DOWNLOAD_URL;
  filePath = filePath?.replace(/^\//, "");
  return `${host}/${filePath}`;
}
export function concatAttachmentsDownloadPath(filePath) {
  let host = process.env.REACT_APP_ATTACHMENTS_DOWNLOAD_URL;
  filePath = filePath?.replace(/^\//, "");
  return `${host}/${filePath}`;
}

export function hasYes(text) {
  // console.warn('text', text)
  // Convert the input string to lowercase
  const lowercasedText = text?.toLowerCase();
  //   console.warn('lowercasedText', lowercasedText)

  // Check if the lowercase string contains the substring "no"
  return lowercasedText?.includes("yes");
}

export const countryData = [
  { name: "Afghanistan", code: "AF" },
  { name: "Åland Islands", code: "AX" },
  { name: "Albania", code: "AL" },
  { name: "Algeria", code: "DZ" },
  { name: "American Samoa", code: "AS" },
  { name: "AndorrA", code: "AD" },
  { name: "Angola", code: "AO" },
  { name: "Anguilla", code: "AI" },
  { name: "Antarctica", code: "AQ" },
  { name: "Antigua and Barbuda", code: "AG" },
  { name: "Argentina", code: "AR" },
  { name: "Armenia", code: "AM" },
  { name: "Aruba", code: "AW" },
  { name: "Australia", code: "AU" },
  { name: "Austria", code: "AT" },
  { name: "Azerbaijan", code: "AZ" },
  { name: "Bahamas", code: "BS" },
  { name: "Bahrain", code: "BH" },
  { name: "Bangladesh", code: "BD" },
  { name: "Barbados", code: "BB" },
  { name: "Belarus", code: "BY" },
  { name: "Belgium", code: "BE" },
  { name: "Belize", code: "BZ" },
  { name: "Benin", code: "BJ" },
  { name: "Bermuda", code: "BM" },
  { name: "Bhutan", code: "BT" },
  { name: "Bolivia", code: "BO" },
  { name: "Bosnia and Herzegovina", code: "BA" },
  { name: "Botswana", code: "BW" },
  { name: "Bouvet Island", code: "BV" },
  { name: "Brazil", code: "BR" },
  { name: "British Indian Ocean Territory", code: "IO" },
  { name: "Brunei Darussalam", code: "BN" },
  { name: "Bulgaria", code: "BG" },
  { name: "Burkina Faso", code: "BF" },
  { name: "Burundi", code: "BI" },
  { name: "Cambodia", code: "KH" },
  { name: "Cameroon", code: "CM" },
  { name: "Canada", code: "CA" },
  { name: "Cape Verde", code: "CV" },
  { name: "Cayman Islands", code: "KY" },
  { name: "Central African Republic", code: "CF" },
  { name: "Chad", code: "TD" },
  { name: "Chile", code: "CL" },
  { name: "China", code: "CN" },
  { name: "Christmas Island", code: "CX" },
  { name: "Cocos (Keeling) Islands", code: "CC" },
  { name: "Colombia", code: "CO" },
  { name: "Comoros", code: "KM" },
  { name: "Congo", code: "CG" },
  { name: "Congo, The Democratic Republic of the", code: "CD" },
  { name: "Cook Islands", code: "CK" },
  { name: "Costa Rica", code: "CR" },
  { name: "Cote D'Ivoire", code: "CI" },
  { name: "Croatia", code: "HR" },
  { name: "Cuba", code: "CU" },
  { name: "Cyprus", code: "CY" },
  { name: "Czech Republic", code: "CZ" },
  { name: "Denmark", code: "DK" },
  { name: "Djibouti", code: "DJ" },
  { name: "Dominica", code: "DM" },
  { name: "Dominican Republic", code: "DO" },
  { name: "Ecuador", code: "EC" },
  { name: "Egypt", code: "EG" },
  { name: "El Salvador", code: "SV" },
  { name: "Equatorial Guinea", code: "GQ" },
  { name: "Eritrea", code: "ER" },
  { name: "Estonia", code: "EE" },
  { name: "Ethiopia", code: "ET" },
  { name: "Falkland Islands (Malvinas)", code: "FK" },
  { name: "Faroe Islands", code: "FO" },
  { name: "Fiji", code: "FJ" },
  { name: "Finland", code: "FI" },
  { name: "France", code: "FR" },
  { name: "French Guiana", code: "GF" },
  { name: "French Polynesia", code: "PF" },
  { name: "French Southern Territories", code: "TF" },
  { name: "Gabon", code: "GA" },
  { name: "Gambia", code: "GM" },
  { name: "Georgia", code: "GE" },
  { name: "Germany", code: "DE" },
  { name: "Ghana", code: "GH" },
  { name: "Gibraltar", code: "GI" },
  { name: "Greece", code: "GR" },
  { name: "Greenland", code: "GL" },
  { name: "Grenada", code: "GD" },
  { name: "Guadeloupe", code: "GP" },
  { name: "Guam", code: "GU" },
  { name: "Guatemala", code: "GT" },
  { name: "Guernsey", code: "GG" },
  { name: "Guinea", code: "GN" },
  { name: "Guinea-Bissau", code: "GW" },
  { name: "Guyana", code: "GY" },
  { name: "Haiti", code: "HT" },
  { name: "Heard Island and Mcdonald Islands", code: "HM" },
  { name: "Holy See (Vatican City State)", code: "VA" },
  { name: "Honduras", code: "HN" },
  { name: "Hong Kong", code: "HK" },
  { name: "Hungary", code: "HU" },
  { name: "Iceland", code: "IS" },
  { name: "India", code: "IN" },
  { name: "Indonesia", code: "ID" },
  { name: "Iran, Islamic Republic Of", code: "IR" },
  { name: "Iraq", code: "IQ" },
  { name: "Ireland", code: "IE" },
  { name: "Isle of Man", code: "IM" },
  { name: "Israel", code: "IL" },
  { name: "Italy", code: "IT" },
  { name: "Jamaica", code: "JM" },
  { name: "Japan", code: "JP" },
  { name: "Jersey", code: "JE" },
  { name: "Jordan", code: "JO" },
  { name: "Kazakhstan", code: "KZ" },
  { name: "Kenya", code: "KE" },
  { name: "Kiribati", code: "KI" },
  { name: "Korea, Democratic People'S Republic of", code: "KP" },
  { name: "Korea, Republic of", code: "KR" },
  { name: "Kuwait", code: "KW" },
  { name: "Kyrgyzstan", code: "KG" },
  { name: "Lao People'S Democratic Republic", code: "LA" },
  { name: "Latvia", code: "LV" },
  { name: "Lebanon", code: "LB" },
  { name: "Lesotho", code: "LS" },
  { name: "Liberia", code: "LR" },
  { name: "Libyan Arab Jamahiriya", code: "LY" },
  { name: "Liechtenstein", code: "LI" },
  { name: "Lithuania", code: "LT" },
  { name: "Luxembourg", code: "LU" },
  { name: "Macao", code: "MO" },
  { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
  { name: "Madagascar", code: "MG" },
  { name: "Malawi", code: "MW" },
  { name: "Malaysia", code: "MY" },
  { name: "Maldives", code: "MV" },
  { name: "Mali", code: "ML" },
  { name: "Malta", code: "MT" },
  { name: "Marshall Islands", code: "MH" },
  { name: "Martinique", code: "MQ" },
  { name: "Mauritania", code: "MR" },
  { name: "Mauritius", code: "MU" },
  { name: "Mayotte", code: "YT" },
  { name: "Mexico", code: "MX" },
  { name: "Micronesia, Federated States of", code: "FM" },
  { name: "Moldova, Republic of", code: "MD" },
  { name: "Monaco", code: "MC" },
  { name: "Mongolia", code: "MN" },
  { name: "Montserrat", code: "MS" },
  { name: "Morocco", code: "MA" },
  { name: "Mozambique", code: "MZ" },
  { name: "Myanmar", code: "MM" },
  { name: "Namibia", code: "NA" },
  { name: "Nauru", code: "NR" },
  { name: "Nepal", code: "NP" },
  { name: "Netherlands", code: "NL" },
  { name: "Netherlands Antilles", code: "AN" },
  { name: "New Caledonia", code: "NC" },
  { name: "New Zealand", code: "NZ" },
  { name: "Nicaragua", code: "NI" },
  { name: "Niger", code: "NE" },
  { name: "Nigeria", code: "NG" },
  { name: "Niue", code: "NU" },
  { name: "Norfolk Island", code: "NF" },
  { name: "Northern Mariana Islands", code: "MP" },
  { name: "Norway", code: "NO" },
  { name: "Oman", code: "OM" },
  { name: "Pakistan", code: "PK" },
  { name: "Palau", code: "PW" },
  { name: "Palestinian Territory, Occupied", code: "PS" },
  { name: "Panama", code: "PA" },
  { name: "Papua New Guinea", code: "PG" },
  { name: "Paraguay", code: "PY" },
  { name: "Peru", code: "PE" },
  { name: "Philippines", code: "PH" },
  { name: "Pitcairn", code: "PN" },
  { name: "Poland", code: "PL" },
  { name: "Portugal", code: "PT" },
  { name: "Puerto Rico", code: "PR" },
  { name: "Qatar", code: "QA" },
  { name: "Reunion", code: "RE" },
  { name: "Romania", code: "RO" },
  { name: "Russian Federation", code: "RU" },
  { name: "RWANDA", code: "RW" },
  { name: "Saint Helena", code: "SH" },
  { name: "Saint Kitts and Nevis", code: "KN" },
  { name: "Saint Lucia", code: "LC" },
  { name: "Saint Pierre and Miquelon", code: "PM" },
  { name: "Saint Vincent and the Grenadines", code: "VC" },
  { name: "Samoa", code: "WS" },
  { name: "San Marino", code: "SM" },
  { name: "Sao Tome and Principe", code: "ST" },
  { name: "Saudi Arabia", code: "SA" },
  { name: "Senegal", code: "SN" },
  { name: "Serbia and Montenegro", code: "CS" },
  { name: "Seychelles", code: "SC" },
  { name: "Sierra Leone", code: "SL" },
  { name: "Singapore", code: "SG" },
  { name: "Slovakia", code: "SK" },
  { name: "Slovenia", code: "SI" },
  { name: "Solomon Islands", code: "SB" },
  { name: "Somalia", code: "SO" },
  { name: "South Africa", code: "ZA" },
  { name: "South Georgia and the South Sandwich Islands", code: "GS" },
  { name: "Spain", code: "ES" },
  { name: "Sri Lanka", code: "LK" },
  { name: "Sudan", code: "SD" },
  { name: "Suriname", code: "SR" },
  { name: "Svalbard and Jan Mayen", code: "SJ" },
  { name: "Swaziland", code: "SZ" },
  { name: "Sweden", code: "SE" },
  { name: "Switzerland", code: "CH" },
  { name: "Syrian Arab Republic", code: "SY" },
  { name: "Taiwan, Province of China", code: "TW" },
  { name: "Tajikistan", code: "TJ" },
  { name: "Tanzania, United Republic of", code: "TZ" },
  { name: "Thailand", code: "TH" },
  { name: "Timor-Leste", code: "TL" },
  { name: "Togo", code: "TG" },
  { name: "Tokelau", code: "TK" },
  { name: "Tonga", code: "TO" },
  { name: "Trinidad and Tobago", code: "TT" },
  { name: "Tunisia", code: "TN" },
  { name: "Turkey", code: "TR" },
  { name: "Turkmenistan", code: "TM" },
  { name: "Turks and Caicos Islands", code: "TC" },
  { name: "Tuvalu", code: "TV" },
  { name: "Uganda", code: "UG" },
  { name: "Ukraine", code: "UA" },
  { name: "United Arab Emirates", code: "AE" },
  { name: "United Kingdom", code: "GB" },
  { name: "United States", code: "US" },
  { name: "United States Minor Outlying Islands", code: "UM" },
  { name: "Uruguay", code: "UY" },
  { name: "Uzbekistan", code: "UZ" },
  { name: "Vanuatu", code: "VU" },
  { name: "Venezuela", code: "VE" },
  { name: "Viet Nam", code: "VN" },
  { name: "Virgin Islands, British", code: "VG" },
  { name: "Virgin Islands, U.S.", code: "VI" },
  { name: "Wallis and Futuna", code: "WF" },
  { name: "Western Sahara", code: "EH" },
  { name: "Yemen", code: "YE" },
  { name: "Zambia", code: "ZM" },
  { name: "Zimbabwe", code: "ZW" },
];
export function emptyHandle(val) {
  return val ? val : "-";
}

export function emptyHandleTwo(val) {
  return !val || val == 0 ? "-" : val;
}

export const clipCopy = (val) => {
  if (val) {
    navigator.clipboard.writeText(val);
  }
};

export const openInNewTab = (url) => {
  if (url) {
    window.open(url, "_blank", "noreferrer");
  }
};

export function formatTime(seconds) {
  seconds = Math.max(0, Math.floor(seconds));
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  // Initialize an empty array to store the time components
  const timeComponents = [];

  // Add hours to the timeComponents array if it's greater than 0
  if (hours > 0) {
    // Add a leading 0 if hours is less than 10
    const formattedHours = hours < 10 ? `0${hours}` : `${hours}`;
    timeComponents.push(formattedHours);
  }

  // Add minutes and seconds with leading 0s if necessary
  const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
  const formattedSeconds =
    remainingSeconds < 10 ? `0${remainingSeconds}` : `${remainingSeconds}`;

  timeComponents.push(formattedMinutes, formattedSeconds);

  // Join the time components with ':' separator

  const formattedTime = timeComponents.join(":");

  return formattedTime;
}

export const getCurrentUTCDateTime = () => {
  // Get the current date and time
  const currentDate = new Date();

  // Define months as an array for month names
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Get the month, day, year, hours, and minutes
  const month = months[currentDate.getUTCMonth()];
  const day = currentDate.getUTCDate();
  const year = currentDate.getUTCFullYear();
  const hours = currentDate.getUTCHours();
  const minutes = currentDate.getUTCMinutes();

  // Convert hours to AM/PM format
  const ampm = hours >= 12 ? "PM" : "AM";

  // Adjust hours to 12-hour format
  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;

  // Add leading zeros to minutes if needed
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  // Construct the formatted date and time string
  const formattedDate = `${month} ${day}, ${year} at ${formattedHours}:${formattedMinutes} ${ampm} UTC`;

  return formattedDate;
};
/**
 * The function returns an object containing years from the current year to 2021.
 * @returns an object containing the years from the current year (obtained using `new
 * Date().getFullYear()`) down to the year 2021. Each year is both the key and the value in the object.
 */

export const years = () => {
  const years = {};
  const currentYear = new Date().getFullYear();

  for (let year = currentYear; year >= 2021; year--) {
    years[year] = year;
  }

  return years;
};

export const noteFinder = (notes, string) => {
  const foundNote = notes?.find((note) => note.type == string);
  return foundNote;
};
export const linkFinder = (links, string) => {
  // console.warn('links', links ,string)
  const foundLink = links?.filter((link) => link.key == string);
  return foundLink;
};

export function truncateString(str, maxLength) {
  // console.warn('str.length', str.length)
  if (!str) return;
  if (str.length <= maxLength) {
    return str;
  } else {
    return str.substring(0, maxLength) + "...";
  }
}

export const styledDateTime = (dateStr) => {
  const parsed_date = new Date(dateStr);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  let hour = parsed_date.getUTCHours();
  let hourFormat = hour >= 12 ? "PM" : "AM";
  hour = hour >= 12 ? hour - 12 : hour;
  const minutes = parsed_date.getUTCMinutes();

  return `${
    months[parsed_date.getUTCMonth()]
  } ${parsed_date.getUTCDate()}, ${parsed_date.getUTCFullYear()} at ${hour}:${
    minutes < 10 ? "0" : ""
  }${minutes} ${hourFormat} UTC`;
};

export const getEarningStatus = (month = "") => {
  const currentMonth = new Date().getMonth();
  const monthIndex = months.includes(month) ? months.indexOf(month) : -1;
  if (monthIndex === currentMonth) return 0;
  if (monthIndex < currentMonth) return 1;
  return -1;
};

const userList = [
  {
    id: 9,
    role: "Content Buyer",
    roleShort: "admin",
  },
  {
    id: 8,
    role: "Normal User",
    roleShort: "admin",
  },
  {
    id: 7,
    role: "Manager",
    roleShort: "manager",
  },
  {
    id: 6,
    role: "Quality Team",
    roleShort: "quality",
  },
  {
    id: 5,
    role: "Copywrite Team",
    roleShort: "copywrite",
  },
  {
    id: 4,
    role: "Editor",
    roleShort: "editor",
  },
  {
    id: 3,
    role: "Partner",
    roleShort: "admin",
  },
  {
    id: 1,
    role: "Administrator",
    roleShort: "admin",
  },
  {
    id: 2,
    role: "Member",
    roleShort: "admin",
  },
];

export const roleFinder = (id) => {
  if (!id) return;
  let user = userList.find((u) => u.id == id);
  return user.role;
};
export const roleFinderTwo = (id) => {
  if (!id) return;
  let user = userList.find((u) => u.id == id);
  return user.roleShort;
};

export function getStartEndDateTwo(monthName, year) {
  const monthValue = monthName - 1;
  if (year && !monthName) {
    return {
      start_date: `${year}-01-01`,
      end_date: `${year}-12-31`,
    };
  }

  if (typeof monthValue !== "undefined" && !isNaN(year)) {
    // Create a Date object for the first day of the specified month and year
    const startDate = new Date(year, monthValue, 1);

    // Calculate the last day of the specified month and year
    const endDate = new Date(year, monthValue + 1, 0);

    // Format the dates as strings in the 'YYYY-MM-DD' format
    const startDateStr = `${startDate.getFullYear()}-${String(
      startDate.getMonth() + 1
    ).padStart(2, "0")}-${String(startDate.getDate()).padStart(2, "0")}`;
    const endDateStr = `${endDate.getFullYear()}-${String(
      endDate.getMonth() + 1
    ).padStart(2, "0")}-${String(endDate.getDate()).padStart(2, "0")}`;

    return {
      start_date: startDateStr,
      end_date: endDateStr,
    };
  } else {
    return null; // Invalid  input
  }
}

export const getPagination = (currentPage, lastPage) => {
  const hasNextPage = currentPage + 1 <= lastPage;
  const hasPrevPage = currentPage - 1 > 0;
  return { hasNextPage, hasPrevPage };
};

export function addDotMiddle(str, maxLength) {
  if (str.length <= maxLength) {
    return str; // No need to truncate, return the original string
  } else {
    const ellipsis = "...";
    const halfLength = Math.floor((maxLength - ellipsis.length) / 2);
    const firstHalf = str.substring(0, halfLength);
    const secondHalf = str.substring(str.length - halfLength);
    return firstHalf + ellipsis + secondHalf;
  }
}
